module.exports = __webpack_public_path__ + "img/products-campers.b3b1a9e0.jpeg";